module.exports = __webpack_public_path__ + "static/media/view4.9c682cd6.jpg";